import {ResourceDrawerActivitiesSection} from '@/shared/components/ui/resource-drawer-sections'
import {useSupportiveMedicationDrugContext} from '@/shared/contexts/supportive-medication-drug'
import {Tabs} from '@chakra-ui/react'

export function HistoryTab() {
  const {activities} = useSupportiveMedicationDrugContext()

  return (
    <Tabs.Content value="history">
      <ResourceDrawerActivitiesSection activities={activities} />
    </Tabs.Content>
  )
}
